import { createSelector } from 'reselect';

const BRANCHES = state => state.Branches.branches;

export const selectBranches = createSelector([BRANCHES], BRANCHES => BRANCHES);
